<div
  class="vehicle-card"
  [class.selected]="isSelected"
  role="button"
  tabindex="0"
  [attr.aria-pressed]="isSelected"
  [attr.aria-label]="'Select vehicle ' + vehicleName"
  (click)="onCardClick($event)"
  (keydown)="onCardKeydown($event)">
  <div>
    <div>
      <div class="radio-button" [class.checked]="isSelected" aria-hidden="true">
        <div class="radio-inner" *ngIf="isSelected"></div>
      </div>
      <span class="vehicle-name">{{ vehicleName }}</span>
    </div>

    <div class="vehicle-actions" *ngIf="showActions">
      <!-- Desktop/Tablet: Show individual action buttons -->
      <div class="desktop-actions">
        <button class="action-btn edit-btn" (click)="onEditVehicle($event)">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.2487 2.41627L12.582 5.7496M1.33203 13.6663H4.66536L13.4154 4.91627C13.6342 4.6974 13.8079 4.43756 13.9263 4.15159C14.0448 3.86563 14.1057 3.55913 14.1057 3.2496C14.1057 2.94007 14.0448 2.63357 13.9263 2.34761C13.8079 2.06164 13.6342 1.8018 13.4154 1.58293C13.1965 1.36406 12.9367 1.19045 12.6507 1.072C12.3647 0.953545 12.0582 0.892578 11.7487 0.892578C11.4392 0.892578 11.1327 0.953545 10.8467 1.072C10.5607 1.19045 10.3009 1.36406 10.082 1.58293L1.33203 10.3329V13.6663Z" stroke="#326FD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="action-btn delete-btn" (click)="onDeleteVehicle($event)">
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.33203 4.83333H14.6654M6.33203 8.16667V13.1667M9.66536 8.16667V13.1667M2.16536 4.83333L2.9987 14.8333C2.9987 15.2754 3.17429 15.6993 3.48685 16.0118C3.79941 16.3244 4.22334 16.5 4.66536 16.5H11.332C11.7741 16.5 12.198 16.3244 12.5105 16.0118C12.8231 15.6993 12.9987 15.2754 12.9987 14.8333L13.832 4.83333M5.4987 4.83333V2.33333C5.4987 2.11232 5.5865 1.90036 5.74278 1.74408C5.89906 1.5878 6.11102 1.5 6.33203 1.5H9.66536C9.68696 1.5 10.0983 1.5878 10.2546 1.74408C10.4109 1.90036 10.4987 2.11232 10.4987 2.33333V4.83333" stroke="#D9342B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Mobile: Show three-dot menu -->
      <div class="mobile-actions">
        <button class="mobile-menu-btn" (click)="toggleMobileMenu($event)" [class.active]="isMenuOpen">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="8" r="1.5" fill="#555A63"/>
            <circle cx="8" cy="8" r="1.5" fill="#555A63"/>
            <circle cx="13" cy="8" r="1.5" fill="#555A63"/>
          </svg>
        </button>

        <!-- Mobile Menu Dropdown -->
        <div class="mobile-menu-dropdown" *ngIf="isMenuOpen" (click)="$event.stopPropagation()">
          <div class="mobile-menu-item" (click)="onMobileEdit()">
            <span>Edit</span>
            <svg class="menu-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.3333 2.00001C11.5084 1.8249 11.7163 1.686 11.9453 1.59128C12.1742 1.49657 12.4191 1.44775 12.6667 1.44775C12.9142 1.44775 13.1591 1.49657 13.3881 1.59128C13.617 1.686 13.8249 1.8249 14 2.00001C14.1751 2.17512 14.314 2.38302 14.4087 2.61197C14.5034 2.84092 14.5522 3.0858 14.5522 3.33334C14.5522 3.58088 14.5034 3.82576 14.4087 4.05471C14.314 4.28366 14.1751 4.49156 14 4.66667L5 13.6667L1.33333 14.6667L2.33333 11L11.3333 2.00001Z" stroke="#555A63" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="mobile-menu-item delete-item" (click)="onMobileDelete()">
            <span>Delete</span>
            <svg class="menu-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 4H3.33333H14" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31305 1.33334 6.66667 1.33334H9.33333C9.68696 1.33334 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31305 14.6667 3.97391 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4H12.6667Z" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.66667 7.33334V11.3333" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.33333 7.33334V11.3333" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="vehicle-details">
    <div class="detail-row">
      <div class="detail-item">
        <span class="detail-label">LICENSE PLATE</span>
        <span class="detail-value">{{ vehicleData.licensePlate || 'N/A' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">VIN NUMBER</span>
        <span class="detail-value">{{ vehicleData.vin || 'N/A' }}</span>
      </div>
    </div>
  </div>
</div>
